import { useTranscription } from './useTranscription';
import { useTranscriptionFlag } from './useTranscriptionFlag';

import { AudioPlayer } from './AudioPlayer';
import { TranscriptionText } from './TranscriptionText';
import { TranscriptionButton } from './TranscriptionButton';
import { Attachment } from './types';
export interface AudioBallonProps {
  messageProps: {
    urlBase64: string;
    errorMessage: string;
    messageId: string;
    mimeType: string;
    authorMessage: string;
    time: string;
    direction: string;
    cuid: string;
  };
  isLoading: boolean;
  urlMedia: string;
  reply_message: string;
  attachments: Attachment[];
  currentChat: any;
}

export function AudioBallon(props: Readonly<AudioBallonProps>) {
  const {
    messageProps: { direction, cuid },
    urlMedia,
    attachments,
    currentChat,
  } = props;

  const {
    isLoading,
    error,
    canTryAgain,
    handleTranscription,
    getText,
    isTranscribed,
  } = useTranscription({
    audioUrl: urlMedia,
    currentTranscription: attachments?.length
      ? attachments[0]?.data?.transcription?.transcription ?? ''
      : '',
  });

  const { canShowTranscription, canUseTranscription } = useTranscriptionFlag();

  return (
    <div
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: direction === 'received' ? 'row' : 'row-reverse',
        maxWidth: '100%',
        width: 'fit-content',
        margin: direction === 'received' ? '0 0 0 8px' : '0 8px 0 0',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '0.25rem',
          minWidth: '200px',
        }}
      >
        <AudioPlayer {...props} />
        {canShowTranscription && <TranscriptionText text={getText()} />}
      </div>
      {canShowTranscription && !isTranscribed && (
        <TranscriptionButton
          isLoading={isLoading}
          error={error}
          canTryAgain={canTryAgain}
          handleTranscription={() => handleTranscription(currentChat, cuid)}
          isEnabled={canUseTranscription}
        />
      )}
    </div>
  );
}
